import React from 'react'
import ReactDOM from 'react-dom'
import videojs from 'video.js'

import { Settings as SettingsIcon } from 'images/bend'
import { SHOW_SETTINGS_EVENT } from '../VideoPlayerContext/customEvents'

const vjsComponent = videojs.getComponent('Button')

class Settings extends vjsComponent {
  constructor(player) {
    super(player)

    this.state = {
      player
    }

    this.toggleShow = this.toggleShowSettings.bind(this)

    player.ready(() => {
      this.mountElement()
    })

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el())
    })

    this.on('click', this.toggleShowSettings)
    // Handle touch events
    this.on('touchstart', this.toggleShowSettings)
  }

  mountElement() {
    ReactDOM.render(this.renderSettingsButton(), this.el())
  }

  toggleShowSettings() {
    this.player().trigger(SHOW_SETTINGS_EVENT)
  }

  renderSettingsButton() {
    return <SettingsIcon />
  }
}

vjsComponent.registerComponent('settings', Settings)

export default Settings
